// Icons
import {
    GridDots,
    AlertCircle,
    Logout,
    Cell,
    Checkbox,
    DeviceTv,
    CircleX,
} from 'tabler-icons-react';

// Route Components
// This should come from pages/ and not from routes.

import Home from '../pages/Home';
// import Inventario from '../pages/Inventario';
import Paros from '../pages/Paros';
import LogOut from '../pages/LogOut';
import InfoCeldas from '../pages/InfoCeldas';
import BuildInfo from '../pages/BuildInfo/index.jsx';
import TVView from '../pages/TV';
import Calidad from '../pages/Calidad';

export const menuItemFilter = {
    home: process.env.REACT_APP_ALLOW_HOME_VIEW === 'true',
    paros: process.env.REACT_APP_ALLOW_PAROS_VIEW === 'true',
    celdas: process.env.REACT_APP_ALLOW_CELDAS_VIEW === 'true',
    calidad: process.env.REACT_APP_ALLOW_CALIDAD === 'true',
};

export const tecnoRouteList = [
    {
        id: 'home',
        text: 'Panel Principal',
        icon: GridDots,
        path: '/',
        component: Home,
    },

    {
        id: 'paros',
        text: 'Paros',
        icon: AlertCircle,
        path: '/Paros',
        component: Paros,
    },
    {
        id: 'celdas',
        text: 'Info Celdas',
        icon: Cell,
        path: '/infoCeldas',
        component: InfoCeldas,
    },
    {
        id: 'calidad',
        text: 'Calidad',
        icon: CircleX,
        path: '/calidad',
        component: Calidad,
    },
    {
        id: 'build-info',
        text: 'build-info',
        icon: Checkbox,
        path: '/dev/build-info',
        component: BuildInfo,
    },
    // Vista TV: se muestra en el menú solo si hay línea configurada (controlado en Menu/index.jsx)
    {
        id: 'tv',
        text: 'Vista TV',
        icon: DeviceTv,
        path: '/tv',
        component: TVView,
    },
];

export const routeList = [
    {
        id: 'home',
        text: 'Panel Principal',
        icon: GridDots,
        path: '/',
        component: Home,
    },

    {
        id: 'paros',
        text: 'Paros',
        icon: AlertCircle,
        path: '/Paros',
        component: Paros,
    },
    {
        id: 'celdas',
        text: 'Info Celdas',
        icon: Cell,
        path: '/infoCeldas',
        component: InfoCeldas,
    },
    {
        id: 'calidad',
        text: 'Calidad',
        icon: CircleX,
        path: '/calidad',
        component: Calidad,
    },
    {
        id: 'build-info',
        text: 'build-info',
        icon: Checkbox,
        path: '/dev/build-info',
        component: BuildInfo,
    },
    // {
    //     id: 'inventario',
    //     text: 'Inventario',
    //     icon: FileBarcode,
    //     path: '/Inventario',
    //     component: Inventario,
    // },
    // Vista TV: no aparece en el menú, accesible por URL directa /tv
    // Solo activa si la estación tiene línea configurada (cookie 'linea')
    {
        id: 'tv',
        text: 'Vista TV',
        icon: null,
        path: '/tv',
        component: TVView,
    },
];

export const cerrarSesion = [
    {
        id: 'LogOut',
        text: 'Cerrar Sesión',
        icon: Logout,
        path: '/LogOut',
        component: LogOut,
    },
];
